import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createElementVNode as _createElementVNode, Fragment as _Fragment, renderList as _renderList, createBlock as _createBlock } from "vue"

const _hoisted_1 = { class: "col bg-modal w-maxC" }
const _hoisted_2 = { class: "row" }
const _hoisted_3 = {
  key: 0,
  class: "mleft-02"
}
const _hoisted_4 = { class: "gridPerson mtop-10" }
const _hoisted_5 = { class: "labelCell mtop-03 gcol-l" }
const _hoisted_6 = { class: "gcol-r" }
const _hoisted_7 = { class: "labelCell mtop-03 gcol-l" }
const _hoisted_8 = { class: "gcol-r" }
const _hoisted_9 = { class: "labelCell mtop-03 gcol-l" }
const _hoisted_10 = { class: "gcol-r" }
const _hoisted_11 = { class: "labelCell mtop-03 gcol-l" }
const _hoisted_12 = { class: "gcol-r" }
const _hoisted_13 = { class: "labelCell mtop-03 gcol-l" }
const _hoisted_14 = { class: "mtop-03 gcol-r" }
const _hoisted_15 = { class: "labelCell-sm mtop-06 gcol-l" }
const _hoisted_16 = { class: "mtop-03 gcol-r row" }
const _hoisted_17 = { class: "bg-modal w-maxC" }
const _hoisted_18 = { class: "labelCell mtop-03 gcol-l" }
const _hoisted_19 = { class: "row" }
const _hoisted_20 = { class: "bg-modal w-maxC" }
const _hoisted_21 = { class: "labelCell mtop-03 gcol-l" }
const _hoisted_22 = { class: "gcol-r flexRow" }
const _hoisted_23 = { class: "bg-modal w-maxC dropd-scroll" }
const _hoisted_24 = { class: "labelCell mtop-03 gcol-l" }
const _hoisted_25 = { class: "gcol-r" }
const _hoisted_26 = { class: "labelCell mtop-03 gcol-l" }
const _hoisted_27 = { class: "gcol-r row" }
const _hoisted_28 = { class: "bg-modal w-maxC dropd-scroll" }
const _hoisted_29 = { class: "labelCell mtop-03 gcol-l" }
const _hoisted_30 = { class: "gcol-r" }
const _hoisted_31 = { class: "addressInputGrid mtop-10" }
const _hoisted_32 = { class: "labelCell mtop-03 gcol-l" }
const _hoisted_33 = { class: "gcol-r" }
const _hoisted_34 = { class: "labelCell mtop-03 gcol-l" }
const _hoisted_35 = { class: "gcol-r" }
const _hoisted_36 = { class: "pad-m rnd-m bg-h" }
const _hoisted_37 = { class: "labelCell mtop-03 gcol-l" }
const _hoisted_38 = { class: "gcol-r" }
const _hoisted_39 = { class: "labelCell mtop-03 gcol-l" }
const _hoisted_40 = { class: "gcol-r" }
const _hoisted_41 = { class: "bg-modal w-maxC dropd-scroll" }

import { ref, computed, onMounted, onUnmounted, watch } from 'vue';
import { useCurrentEntryStore } from '@/stores/currentEntry'
import { LANGUAGE_LIST } from "@/functions/geo.js"
import { GENDER_LIST, GENDER_TERMS, BIOLOGICAL_SEX_LIST, BIOLOGICAL_SEX_TERMS, getDefaultPersonItem } from "@/functions/office"
import { apiDateString } from "@/api/apicommon"
import gen from "@/functions/general.js"
import officeapi from "@/api/officeapi"
import relationshipapi from "@/api/relationshipapi"
import { getFlagEmojiForCountry, getFlagEmojiForPrefix, PHONE_PREFIX_LIST, COUNTRY_LIST } from '@/functions/geo.js'
import { medServerApiConfig } from '@/config/medserver-api.config';
import { ApiError, PersonApi, UpdatePersonWithRoleAddressRequest, UpdatePersonWithRoleEmailRequest, UpdatePersonWithRolePhoneRequest } from '@/apiGenerate/medserver';
import { useI18n } from 'vue-i18n';
import { Language, Phone, Address } from '@/models/entourage.model'
import { toastError, toastSuccess } from '@/utils/toast-utils';
import { useToast } from 'primevue'


export default /*@__PURE__*/_defineComponent({
  __name: 'entouragePersonInput',
  props: {
  person: {
    type: Object,
    required: true,
  },
},
  emits: ['close'],
  setup(__props, { emit: __emit }) {

const currentEntryStore = useCurrentEntryStore()
const personApi = new PersonApi(medServerApiConfig);
const { t } = useI18n();
const toast = useToast();

const props = __props
const emits = __emit
const focusRef = ref(null)
const dropd = ref<string>("")
const noUpdate = ref<boolean>(false)
const currentLanguages = ref<Language[]>(gen.deepCopy(props.person.languages) || [])
const firstNameInput = ref<string>(props.person?.firstName || "")
const lastNameInput = ref<string>((props.person?.lastName || "").toUpperCase())
const nameAtBirthInput = ref<string>(props.person?.nameAtBirth || "")
const currentGenderType = ref<keyof typeof GENDER_TERMS | undefined>(props.person?.gender)
const currentBiologicalSexType = ref<keyof typeof BIOLOGICAL_SEX_TERMS | undefined>(props.person?.biologicalSex)
const relationDescriptionInput = ref<string>(props.person.relation?.description || "")
const relationNoteInput = ref<string>(props.person.relation?.note || "")

const phoneInput = ref<Phone>({
  ...(getDefaultPersonItem(props.person?.phones) || {
    phonePrefix: undefined,
    phoneNumber: undefined
  })
})
const emailInput = ref<string>(
  getDefaultPersonItem(props.person?.emails)?.email || undefined
)
const adressInput = ref<Address>({
  ...(getDefaultPersonItem(props.person?.addresses) || {
    street: undefined,
    postalCode: undefined,
    locality: undefined,
    isoCountry: undefined,
    postalCodePrefix: undefined
  })
});

const isCurrPatient = computed(() => {
  return currentEntryStore.modalPatient.personWithRoleId === props.person.personWithRoleId
})
const birthDate = computed(() => {
  if (!currentEntryStore.modalPatient) return ""
  return apiDateString(currentEntryStore.modalPatient.birthDate)
})
const filteredLanguageList = computed(() => {
  return LANGUAGE_LIST
    .filter(listLanguage => !currentLanguages.value.some(pwrLanguage => pwrLanguage.languageIso === listLanguage.languageIso))
})

const originalPhone = getDefaultPersonItem(props.person?.phones) || {}
const originalEmail = getDefaultPersonItem(props.person?.emails) || {}
const originalAdress = getDefaultPersonItem(props.person?.addresses) || {}

/**
 * Set the selected country ISO code for the address input.
 * @param {Object} country - The selected country object (must contain isoCode).
 */
const setCountry = (country: { isoCode: string }): void => {
  adressInput.value.isoCountry = country.isoCode
  dropd.value = ""
}

/**
 * Set the selected phone prefix in the phone input.
 * @param {Object} prefixPhone - The selected phone prefix object (must contain prefix).
 */
const setPrefix = (prefixPhone: { prefix: string }): void => {
  phoneInput.value.phonePrefix = prefixPhone.prefix
  dropd.value = ""
}

/**
 * Add a new language to the current language list.
 * @param {Object} lang - The language object to add.
 */
const addLanguage = (lang: { languageIso: string; term: string; }): void => {
  currentLanguages.value.push(lang as unknown as Language);
  dropd.value = '';
}

/**
 * Remove a language from the current language list.
 * @param {Object} lang - The language object to remove.
 */
const removeLanguage = (lang: Language): void => {
  const isoToRemove = lang.languageIso
  const index = currentLanguages.value.findIndex(pwrLanguage => pwrLanguage.languageIso === isoToRemove)
  currentLanguages.value.splice(index, 1)
}

/**
 * Update the person's languages by comparing added/removed ones.
 * @returns {Promise<boolean>} - True if an update was made, false otherwise.
 */
const updatePwrLanguages = async (): Promise<boolean> => {
  const newList = currentLanguages.value.map(lang => lang.languageIso)
  const oldList = props.person.languages.map((lang: { languageIso: string }) => lang.languageIso)
  const added = newList.filter(iso => !oldList.includes(iso))
  const removed = oldList.filter((iso: string) => !newList.includes(iso))
  if (!added.length && !removed.length) return false
  const personWithRoleId = props.person.personWithRoleId
  for (const languageIso of added) {
    await officeapi.addLanguageToPwr(personWithRoleId, languageIso)
  }
  for (const languageIso of removed) {
    await officeapi.removeLanguageFromPwr(personWithRoleId, languageIso)
  }
  return true
}

/**
 * Update the person's first name if changed.
 * @returns {Promise<boolean>} - True if updated, false otherwise.
 */
const updatePwrFirstName = async (): Promise<boolean> => {
  if (props.person.firstName === firstNameInput.value) return false
  const personWithRoleId = props.person.personWithRoleId
  const newText = firstNameInput.value
  await officeapi.updatePwrFirstName(personWithRoleId, newText)
  return true
}

/**
 * Update the person's last name if changed.
 * @returns {Promise<boolean>} - True if updated, false otherwise.
 */
const updatePwrLastName = async (): Promise<boolean> => {
  if (props.person.lastName === lastNameInput.value) return false
  const personWithRoleId = props.person.personWithRoleId
  const newText = lastNameInput.value
  await officeapi.updatePwrLastName(personWithRoleId, newText)
  return true
}

/**
 * Update the person's name at birth if changed.
 * @returns {Promise<boolean>} - True if updated, false otherwise.
 */
const updatePwrNameAtBirth = async (): Promise<boolean> => {
  if (props.person.nameAtBirth === nameAtBirthInput.value) return false
  const personWithRoleId = props.person.personWithRoleId;
  const newText = nameAtBirthInput.value;
  await officeapi.updatePwrNameAtBirth(personWithRoleId, newText);
  return true;
}

/**
 * Set the selected gender type.
 * @param {string} genderType - The selected gender type.
 */
const setGenderType = (genderType: string): void => {
  currentGenderType.value = genderType as keyof typeof GENDER_TERMS;
  dropd.value = "";
}

/**
 * Update the person's gender type if changed.
 * @returns {Promise<boolean>} - True if updated, false otherwise.
 */
const updatePwrGenderType = async (): Promise<boolean> => {
  if (!isCurrPatient.value) return false
  if (props.person.gender === currentGenderType.value) return false
  const personWithRoleId = props.person.personWithRoleId
  const newText = currentGenderType.value
  await officeapi.updatePwrGenderType(personWithRoleId, newText)
  return true
}

/**
 * Set the selected biological sex.
 * @param {string} biologicalSexType - The selected biological sex.
 */
const setBiologicalSex = (biologicalSexType: string): void => {
  currentBiologicalSexType.value = biologicalSexType as keyof typeof BIOLOGICAL_SEX_TERMS;
  dropd.value = ""
}

/**
 * Update the person's biological sex if changed.
 * @returns {Promise<boolean>} - True if updated, false otherwise.
 */
const updatePwrBiologicalSexType = async (): Promise<boolean> => {
  if (!isCurrPatient.value) return false
  if (props.person.biologicalSex === currentBiologicalSexType.value) return false
  const personWithRoleId = props.person.personWithRoleId
  const newText = currentBiologicalSexType.value
  await officeapi.updatePwrBiologicalSexType(personWithRoleId, newText)
  return true
}

/**
 * Update the description of the relationship if changed.
 * @returns {Promise<boolean>} - True if updated, false otherwise.
 */
const updatePatientPersonDescription = async (): Promise<boolean> => {
  if (isCurrPatient.value) return false
  if (props.person.relation?.description === relationDescriptionInput.value) return false
  const relationshipId = props.person.relation.relationshipId
  const newText = relationDescriptionInput.value
  await relationshipapi.updatePatientPersonDescription(relationshipId, newText)
  return true
}

/**
 * Delete the current relative based on their relationshipId.
 * @returns {Promise<boolean>} - True if deleted.
 */
const deleteRelative = async (): Promise<boolean> => {
  const relationshipId = props.person.relation.relationshipId
  await relationshipapi.deleteRelative(relationshipId)
  emits('close')
  return true
}

/**
 * Update the note associated with the relationship if changed.
 * @returns {Promise<boolean>} - True if updated, false otherwise.
 */
const updatePatientPersonNote = async (): Promise<boolean> => {
  if (isCurrPatient.value) return false
  if (props.person.relation?.note === relationNoteInput.value) return false
  const relationshipId = props.person.relation.relationshipId
  const newText = relationNoteInput.value
  await relationshipapi.updatePatientPersonNote(relationshipId, newText)
  return true
}

/**
 * Update the phone number and prefix if changed.
 * @returns {Promise<boolean>} - True if updated, false otherwise.
 */
const updatePwrPhone = async (): Promise<boolean> => {
  if (
    originalPhone.phoneNumber === phoneInput.value.phoneNumber &&
    originalPhone.phonePrefix === phoneInput.value.phonePrefix
  ) return false

  const request: UpdatePersonWithRolePhoneRequest = {
    personId: props.person.personWithRoleId,
    updatePhonePwrRequest: {
      phone: phoneInput.value.phoneNumber,
      prefixPhone: phoneInput.value.phonePrefix
    }
  }

  await personApi.updatePersonWithRolePhone(request).then(() => {
    toastSuccess(toast, {
        summary: t('common.toast.success.update'),
        detail:  t('patient.entourageCard.updateSuccess')
    });
    return true
  }).catch((error: ApiError) => {
    toastError(toast, {
        summary: t('common.toast.error'),
        detail: t(`error.${error.status}`)
    });
  });
}

/**
 * Update the email address if changed.
 * @returns {Promise<boolean>} - True if updated, false otherwise.
 */
const updatePwrEmail = async (): Promise<boolean> => {
  if (originalEmail.email === emailInput.value) return false

  const request: UpdatePersonWithRoleEmailRequest = {
    personId: props.person.personWithRoleId,
    updateEmailPwrRequest: {
      email: emailInput.value
    }
  }

  await personApi.updatePersonWithRoleEmail(request).then(() => {
    toastSuccess(toast, {
        summary: t('common.toast.success.update'),
        detail:  t('patient.entourageCard.updateSuccess')
    });
    return true
  }).catch((error: ApiError) => {
    toastError(toast, {
        summary: t('common.toast.error'),
        detail: t(`error.${error.status}`)
    });
  });
}

/**
 * Update the postal address if changed.
 * @returns {Promise<boolean>} - True if updated, false otherwise.
 */
const updatePwrAdress = async (): Promise<boolean> => {
  if (isSameAddress(originalAdress, adressInput.value)) return false

  const requestUpdate: UpdatePersonWithRoleAddressRequest = {
    personId: props.person.personWithRoleId,
    updateAdressPwrRequest: {
      street: adressInput.value.street,
      postalCode: adressInput.value.postalCode,
      locality: adressInput.value.locality,
      isoCountry: adressInput.value.isoCountry
    }
  }

  await personApi.updatePersonWithRoleAddress(requestUpdate).then(() => {
    toastSuccess(toast, {
        summary: t('common.toast.success.update'),
        detail:  t('patient.entourageCard.updateSuccess')
    });
    return true
  }).catch((error: ApiError) => {
    toastError(toast, {
        summary: t('common.toast.error'),
        detail: t(`error.${error.status}`)
    });
  });
}

/**
 * Compare two address objects and determine if they are the same.
 * @param {Object} a - First address object.
 * @param {Object} b - Second address object.
 * @returns {boolean} - True if addresses are identical.
 */
const isSameAddress = (a: Address, b: Address): boolean => {
  return (
    a.street === b.street &&
    a.postalCode === b.postalCode &&
    a.locality === b.locality &&
    a.isoCountry === b.isoCountry
  )
}

/**
 * Lifecycle hook called when component is mounted.
 * Focuses on the main input field.
 */
onMounted(() => {
  focusRef.value.innerRef.focus()
})

/**
 * Lifecycle hook called when component is unmounted.
 * Triggers all field updates and refreshes patient store if any update occurred.
 */
onUnmounted(async () => {
  if (noUpdate.value || !props.person) return;
  let updated = false
  updated = await updatePwrFirstName() || updated
  updated = await updatePwrLastName() || updated
  updated = await updatePwrNameAtBirth() || updated
  updated = await updatePwrGenderType() || updated
  updated = await updatePwrBiologicalSexType() || updated
  updated = await updatePwrLanguages() || updated
  updated = await updatePatientPersonDescription() || updated
  updated = await updatePatientPersonNote() || updated
  updated = await updatePwrPhone() || updated
  updated = await updatePwrEmail() || updated
  updated = await updatePwrAdress() || updated
  if (updated) await currentEntryStore.reloadPatientOnly();
})

watch(() => adressInput.value.isoCountry, (newIsoCountry) => {
  if (newIsoCountry && typeof newIsoCountry === 'string') {
    adressInput.value.postalCodePrefix = newIsoCountry.charAt(0).toUpperCase()
  } 
})


return (_ctx: any,_cache: any) => {
  const _component_text_item = _resolveComponent("text-item")!
  const _component_svg_item = _resolveComponent("svg-item")!
  const _component_button_group = _resolveComponent("button-group")!
  const _component_inputLineNew2 = _resolveComponent("inputLineNew2")!
  const _component_inputBox = _resolveComponent("inputBox")!
  const _component_buttonGroup = _resolveComponent("buttonGroup")!
  const _component_input_box = _resolveComponent("input-box")!
  const _component_list_group = _resolveComponent("list-group")!
  const _component_dbGroup = _resolveComponent("dbGroup")!
  const _component_dropdownBox = _resolveComponent("dropdownBox")!
  const _component_deleteItemIcon = _resolveComponent("deleteItemIcon")!
  const _component_inputAreaAuto2 = _resolveComponent("inputAreaAuto2")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createVNode(_component_text_item, {
        txt: _unref(t)('patient.entourageCard.person'),
        styles: "font-l"
      }, null, 8, ["txt"]),
      (!isCurrPatient.value)
        ? (_openBlock(), _createElementBlock("div", _hoisted_3, [
            _createVNode(_component_button_group, {
              onClick: _cache[0] || (_cache[0] = ($event: any) => (deleteRelative()))
            }, {
              default: _withCtx(() => [
                _createVNode(_component_svg_item, {
                  icon: "trash",
                  styles: "main-m size-m"
                })
              ]),
              _: 1
            })
          ]))
        : _createCommentVNode("", true)
    ]),
    _createElementVNode("div", _hoisted_4, [
      _createElementVNode("div", _hoisted_5, [
        _createVNode(_component_text_item, {
          txt: _unref(t)('patient.entourageCard.name')
        }, null, 8, ["txt"])
      ]),
      _createElementVNode("div", _hoisted_6, [
        _createVNode(_component_inputBox, null, {
          default: _withCtx(() => [
            _createVNode(_component_inputLineNew2, {
              ref_key: "focusRef",
              ref: focusRef,
              modelValue: lastNameInput.value,
              "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((lastNameInput).value = $event))
            }, null, 8, ["modelValue"])
          ]),
          _: 1
        })
      ]),
      (isCurrPatient.value)
        ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
            _createElementVNode("div", _hoisted_7, [
              _createVNode(_component_text_item, {
                txt: _unref(t)('patient.entourageCard.birthName')
              }, null, 8, ["txt"])
            ]),
            _createElementVNode("div", _hoisted_8, [
              _createVNode(_component_inputBox, null, {
                default: _withCtx(() => [
                  _createVNode(_component_inputLineNew2, {
                    modelValue: nameAtBirthInput.value,
                    "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((nameAtBirthInput).value = $event))
                  }, null, 8, ["modelValue"])
                ]),
                _: 1
              })
            ])
          ], 64))
        : _createCommentVNode("", true),
      _createElementVNode("div", _hoisted_9, [
        _createVNode(_component_text_item, {
          txt: _unref(t)('patient.entourageCard.firstName')
        }, null, 8, ["txt"])
      ]),
      _createElementVNode("div", _hoisted_10, [
        _createVNode(_component_inputBox, null, {
          default: _withCtx(() => [
            _createVNode(_component_inputLineNew2, {
              modelValue: firstNameInput.value,
              "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((firstNameInput).value = $event))
            }, null, 8, ["modelValue"])
          ]),
          _: 1
        })
      ]),
      (!isCurrPatient.value)
        ? (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
            _createElementVNode("div", _hoisted_11, [
              _createVNode(_component_text_item, {
                txt: _unref(t)('patient.entourageCard.link')
              }, null, 8, ["txt"])
            ]),
            _createElementVNode("div", _hoisted_12, [
              _createVNode(_component_inputBox, null, {
                default: _withCtx(() => [
                  _createVNode(_component_inputLineNew2, {
                    modelValue: relationDescriptionInput.value,
                    "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => ((relationDescriptionInput).value = $event))
                  }, null, 8, ["modelValue"])
                ]),
                _: 1
              })
            ])
          ], 64))
        : _createCommentVNode("", true),
      (isCurrPatient.value)
        ? (_openBlock(), _createElementBlock(_Fragment, { key: 2 }, [
            _createElementVNode("div", _hoisted_13, [
              _createVNode(_component_text_item, {
                txt: _unref(t)('patient.entourageCard.birthDate')
              }, null, 8, ["txt"])
            ]),
            _createElementVNode("div", _hoisted_14, [
              _createVNode(_component_text_item, {
                txt: birthDate.value,
                styles: "main-m",
                class: "mleft-05"
              }, null, 8, ["txt"])
            ])
          ], 64))
        : _createCommentVNode("", true),
      (isCurrPatient.value)
        ? (_openBlock(), _createElementBlock(_Fragment, { key: 3 }, [
            _createElementVNode("div", _hoisted_15, [
              _createVNode(_component_text_item, {
                txt: _unref(t)('patient.entourageCard.gender')
              }, null, 8, ["txt"])
            ]),
            _createElementVNode("div", _hoisted_16, [
              _createVNode(_component_dropdownBox, {
                modelValue: dropd.value,
                "onUpdate:modelValue": _cache[5] || (_cache[5] = ($event: any) => ((dropd).value = $event)),
                openOn: "EditGender"
              }, {
                dropd: _withCtx(() => [
                  _createElementVNode("div", _hoisted_17, [
                    _createVNode(_component_dbGroup, null, {
                      default: _withCtx(() => [
                        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(GENDER_LIST), (gender, index) => {
                          return (_openBlock(), _createBlock(_component_list_group, {
                            key: index,
                            styles: "pad-s",
                            onClick: ($event: any) => (setGenderType(gender))
                          }, {
                            default: _withCtx(() => [
                              _createVNode(_component_text_item, {
                                txt: _unref(GENDER_TERMS)[gender as keyof typeof GENDER_TERMS]
                              }, null, 8, ["txt"])
                            ]),
                            _: 2
                          }, 1032, ["onClick"]))
                        }), 128))
                      ]),
                      _: 1
                    })
                  ])
                ]),
                default: _withCtx(() => [
                  _createVNode(_component_input_box, null, {
                    default: _withCtx(() => [
                      _createVNode(_component_buttonGroup, null, {
                        default: _withCtx(() => [
                          _createVNode(_component_text_item, {
                            txt: _unref(GENDER_TERMS)[currentGenderType.value]
                          }, null, 8, ["txt"])
                        ]),
                        _: 1
                      })
                    ]),
                    _: 1
                  })
                ]),
                _: 1
              }, 8, ["modelValue"])
            ])
          ], 64))
        : _createCommentVNode("", true),
      (isCurrPatient.value)
        ? (_openBlock(), _createElementBlock(_Fragment, { key: 4 }, [
            _createElementVNode("div", _hoisted_18, [
              _createVNode(_component_text_item, {
                txt: _unref(t)('patient.entourageCard.biologicalSex')
              }, null, 8, ["txt"])
            ]),
            _createElementVNode("div", _hoisted_19, [
              _createVNode(_component_dropdownBox, {
                modelValue: dropd.value,
                "onUpdate:modelValue": _cache[6] || (_cache[6] = ($event: any) => ((dropd).value = $event)),
                openOn: "EditSex"
              }, {
                dropd: _withCtx(() => [
                  _createElementVNode("div", _hoisted_20, [
                    _createVNode(_component_dbGroup, null, {
                      default: _withCtx(() => [
                        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(BIOLOGICAL_SEX_LIST), (sex, index) => {
                          return (_openBlock(), _createBlock(_component_list_group, {
                            key: index,
                            styles: "pad-s",
                            onClick: ($event: any) => (setBiologicalSex(sex))
                          }, {
                            default: _withCtx(() => [
                              _createVNode(_component_text_item, {
                                txt: _unref(BIOLOGICAL_SEX_TERMS)[sex as keyof typeof BIOLOGICAL_SEX_TERMS]
                              }, null, 8, ["txt"])
                            ]),
                            _: 2
                          }, 1032, ["onClick"]))
                        }), 128))
                      ]),
                      _: 1
                    })
                  ])
                ]),
                default: _withCtx(() => [
                  _createVNode(_component_input_box, null, {
                    default: _withCtx(() => [
                      _createVNode(_component_buttonGroup, null, {
                        default: _withCtx(() => [
                          _createVNode(_component_text_item, {
                            txt: _unref(BIOLOGICAL_SEX_TERMS)[currentBiologicalSexType.value]
                          }, null, 8, ["txt"])
                        ]),
                        _: 1
                      })
                    ]),
                    _: 1
                  })
                ]),
                _: 1
              }, 8, ["modelValue"])
            ])
          ], 64))
        : _createCommentVNode("", true),
      _createElementVNode("div", _hoisted_21, [
        _createVNode(_component_text_item, {
          txt: _unref(t)('patient.entourageCard.languages')
        }, null, 8, ["txt"])
      ]),
      _createElementVNode("div", _hoisted_22, [
        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(currentLanguages.value, (pwrLanguage, index) => {
          return (_openBlock(), _createBlock(_component_button_group, {
            key: index,
            class: "trigger bg-soloitem",
            onClick: ($event: any) => (removeLanguage(pwrLanguage))
          }, {
            default: _withCtx(() => [
              _createVNode(_component_text_item, {
                txt: pwrLanguage.languageIso
              }, null, 8, ["txt"]),
              _createVNode(_component_deleteItemIcon)
            ]),
            _: 2
          }, 1032, ["onClick"]))
        }), 128)),
        (filteredLanguageList.value.length)
          ? (_openBlock(), _createBlock(_component_dropdownBox, {
              key: 0,
              combo: true,
              modelValue: dropd.value,
              "onUpdate:modelValue": _cache[7] || (_cache[7] = ($event: any) => ((dropd).value = $event)),
              openOn: "Lang"
            }, {
              dropd: _withCtx(() => [
                _createElementVNode("div", _hoisted_23, [
                  _createVNode(_component_dbGroup, null, {
                    default: _withCtx(() => [
                      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(filteredLanguageList.value, (listLanguage, index) => {
                        return (_openBlock(), _createBlock(_component_list_group, {
                          key: index,
                          styles: "pad-s",
                          onClick: ($event: any) => (addLanguage(listLanguage))
                        }, {
                          default: _withCtx(() => [
                            _createVNode(_component_text_item, {
                              txt: listLanguage.languageIso,
                              styles: "main-h",
                              class: "textCell align-r"
                            }, null, 8, ["txt"]),
                            _createVNode(_component_text_item, {
                              txt: listLanguage.term,
                              class: "mleft-08",
                              styles: "main-m"
                            }, null, 8, ["txt"])
                          ]),
                          _: 2
                        }, 1032, ["onClick"]))
                      }), 128))
                    ]),
                    _: 1
                  })
                ])
              ]),
              default: _withCtx(() => [
                _createVNode(_component_buttonGroup, null, {
                  default: _withCtx(() => [
                    _createVNode(_component_svg_item, { icon: "plus" })
                  ]),
                  _: 1
                })
              ]),
              _: 1
            }, 8, ["modelValue"]))
          : _createCommentVNode("", true)
      ]),
      (!isCurrPatient.value)
        ? (_openBlock(), _createElementBlock(_Fragment, { key: 5 }, [
            _createElementVNode("div", _hoisted_24, [
              _createVNode(_component_text_item, {
                txt: _unref(t)('patient.entourageCard.note')
              }, null, 8, ["txt"])
            ]),
            _createElementVNode("div", _hoisted_25, [
              _createVNode(_component_inputBox, null, {
                default: _withCtx(() => [
                  _createVNode(_component_inputAreaAuto2, {
                    modelValue: relationNoteInput.value,
                    "onUpdate:modelValue": _cache[8] || (_cache[8] = ($event: any) => ((relationNoteInput).value = $event)),
                    lines: 3
                  }, null, 8, ["modelValue"])
                ]),
                _: 1
              })
            ])
          ], 64))
        : _createCommentVNode("", true),
      _createElementVNode("div", _hoisted_26, [
        _createVNode(_component_text_item, {
          txt: _unref(t)('patient.entourageCard.phone')
        }, null, 8, ["txt"])
      ]),
      _createElementVNode("div", _hoisted_27, [
        _createVNode(_component_dropdownBox, {
          modelValue: dropd.value,
          "onUpdate:modelValue": _cache[9] || (_cache[9] = ($event: any) => ((dropd).value = $event)),
          openOn: "editPhonePrefix"
        }, {
          dropd: _withCtx(() => [
            _createElementVNode("div", _hoisted_28, [
              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(PHONE_PREFIX_LIST), (country, index) => {
                return (_openBlock(), _createBlock(_component_list_group, {
                  key: index,
                  styles: "pad-s",
                  onClick: ($event: any) => (setPrefix(country))
                }, {
                  default: _withCtx(() => [
                    _createVNode(_component_text_item, {
                      txt: _unref(getFlagEmojiForCountry)(country.isoCode)
                    }, null, 8, ["txt"]),
                    _createVNode(_component_text_item, {
                      txt: '+' + country.prefix,
                      styles: "main-m",
                      class: "mleft-03 align-r"
                    }, null, 8, ["txt"]),
                    _createVNode(_component_text_item, {
                      txt: country.term,
                      class: "mleft-08"
                    }, null, 8, ["txt"])
                  ]),
                  _: 2
                }, 1032, ["onClick"]))
              }), 128))
            ])
          ]),
          default: _withCtx(() => [
            _createVNode(_component_inputBox, null, {
              default: _withCtx(() => [
                _createVNode(_component_buttonGroup, null, {
                  default: _withCtx(() => [
                    _createVNode(_component_text_item, {
                      txt: _unref(getFlagEmojiForPrefix)(phoneInput.value.phonePrefix)
                    }, null, 8, ["txt"]),
                    _createVNode(_component_text_item, {
                      txt: '+' + (phoneInput.value.phonePrefix ?? ''),
                      styles: "main-m",
                      class: "mleft-03"
                    }, null, 8, ["txt"])
                  ]),
                  _: 1
                })
              ]),
              _: 1
            })
          ]),
          _: 1
        }, 8, ["modelValue"]),
        _cache[16] || (_cache[16] = _createElementVNode("div", { class: "mleft-06" }, null, -1)),
        _createVNode(_component_inputBox, null, {
          default: _withCtx(() => [
            _createVNode(_component_inputLineNew2, {
              ref_key: "focusRef",
              ref: focusRef,
              modelValue: phoneInput.value.phoneNumber,
              "onUpdate:modelValue": _cache[10] || (_cache[10] = ($event: any) => ((phoneInput.value.phoneNumber) = $event)),
              onKeydown: _unref(gen).onlyInteger
            }, null, 8, ["modelValue", "onKeydown"])
          ]),
          _: 1
        })
      ]),
      _createElementVNode("div", _hoisted_29, [
        _createVNode(_component_text_item, {
          txt: _unref(t)('patient.entourageCard.email')
        }, null, 8, ["txt"])
      ]),
      _createElementVNode("div", _hoisted_30, [
        _createVNode(_component_inputBox, null, {
          default: _withCtx(() => [
            _createVNode(_component_inputLineNew2, {
              modelValue: emailInput.value,
              "onUpdate:modelValue": _cache[11] || (_cache[11] = ($event: any) => ((emailInput).value = $event))
            }, null, 8, ["modelValue"])
          ]),
          _: 1
        })
      ])
    ]),
    _createElementVNode("div", _hoisted_31, [
      _createElementVNode("div", _hoisted_32, [
        _createVNode(_component_text_item, {
          txt: _unref(t)('patient.entourageCard.street')
        }, null, 8, ["txt"])
      ]),
      _createElementVNode("div", _hoisted_33, [
        _createVNode(_component_inputBox, null, {
          default: _withCtx(() => [
            _createVNode(_component_inputLineNew2, {
              ref_key: "focusRef",
              ref: focusRef,
              modelValue: adressInput.value.street,
              "onUpdate:modelValue": _cache[12] || (_cache[12] = ($event: any) => ((adressInput.value.street) = $event))
            }, null, 8, ["modelValue"])
          ]),
          _: 1
        })
      ]),
      _createElementVNode("div", _hoisted_34, [
        _createVNode(_component_text_item, {
          txt: _unref(t)('patient.entourageCard.postalCode')
        }, null, 8, ["txt"])
      ]),
      _createElementVNode("div", _hoisted_35, [
        _createVNode(_component_inputBox, { class: "row-stretch" }, {
          default: _withCtx(() => [
            (adressInput.value.postalCode)
              ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                  _createElementVNode("div", _hoisted_36, [
                    _createVNode(_component_text_item, {
                      txt: adressInput.value.postalCodePrefix || adressInput.value.isoCountry.charAt(0).toUpperCase(),
                      styles: "main-m",
                      class: "marg-04"
                    }, null, 8, ["txt"])
                  ]),
                  _cache[17] || (_cache[17] = _createElementVNode("div", null, [
                    _createElementVNode("div", { class: "line-v" })
                  ], -1))
                ], 64))
              : _createCommentVNode("", true),
            _createVNode(_component_inputLineNew2, {
              modelValue: adressInput.value.postalCode,
              "onUpdate:modelValue": _cache[13] || (_cache[13] = ($event: any) => ((adressInput.value.postalCode) = $event))
            }, null, 8, ["modelValue"])
          ]),
          _: 1
        })
      ]),
      _createElementVNode("div", _hoisted_37, [
        _createVNode(_component_text_item, {
          txt: _unref(t)('patient.entourageCard.locality')
        }, null, 8, ["txt"])
      ]),
      _createElementVNode("div", _hoisted_38, [
        _createVNode(_component_inputBox, null, {
          default: _withCtx(() => [
            _createVNode(_component_inputLineNew2, {
              modelValue: adressInput.value.locality,
              "onUpdate:modelValue": _cache[14] || (_cache[14] = ($event: any) => ((adressInput.value.locality) = $event))
            }, null, 8, ["modelValue"])
          ]),
          _: 1
        })
      ]),
      _createElementVNode("div", _hoisted_39, [
        _createVNode(_component_text_item, {
          txt: _unref(t)('patient.entourageCard.country')
        }, null, 8, ["txt"])
      ]),
      _createElementVNode("div", _hoisted_40, [
        _createVNode(_component_dropdownBox, {
          modelValue: dropd.value,
          "onUpdate:modelValue": _cache[15] || (_cache[15] = ($event: any) => ((dropd).value = $event)),
          openOn: "editAddressCountry"
        }, {
          dropd: _withCtx(() => [
            _createElementVNode("div", _hoisted_41, [
              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(COUNTRY_LIST), (country, index) => {
                return (_openBlock(), _createBlock(_component_list_group, {
                  key: index,
                  styles: "pad-s",
                  onClick: ($event: any) => (setCountry(country))
                }, {
                  default: _withCtx(() => [
                    _createVNode(_component_text_item, {
                      txt: _unref(getFlagEmojiForCountry)(country.isoCode)
                    }, null, 8, ["txt"]),
                    _createVNode(_component_text_item, {
                      txt: country.term,
                      class: "mleft-08"
                    }, null, 8, ["txt"])
                  ]),
                  _: 2
                }, 1032, ["onClick"]))
              }), 128))
            ])
          ]),
          default: _withCtx(() => [
            _createVNode(_component_inputBox, null, {
              default: _withCtx(() => [
                _createVNode(_component_buttonGroup, { class: "w-full row" }, {
                  default: _withCtx(() => [
                    _createVNode(_component_text_item, {
                      txt: _unref(getFlagEmojiForCountry)(adressInput.value.isoCountry),
                      class: "mleft-02"
                    }, null, 8, ["txt"]),
                    _createVNode(_component_text_item, {
                      txt: _unref(COUNTRY_LIST).find(c => c.isoCode === adressInput.value.isoCountry)?.term || '',
                      class: "mleft-04"
                    }, null, 8, ["txt"])
                  ]),
                  _: 1
                })
              ]),
              _: 1
            })
          ]),
          _: 1
        }, 8, ["modelValue"])
      ])
    ])
  ]))
}
}

})